module.exports = __webpack_public_path__ + "img/9.c13d77de.jpg";